<template>
    <div class="my-balance" v-if="company && (company.signatureType == 'P' || company.signatureType == 'T')">
        <div class="mu-alert error" v-if="balanceIsEnding">
            <font-awesome-icon icon="exclamation-triangle" /> Existem serviços sem crédito, faça uma recarga com seu representante comercial para voltar a utilizar o serviço.
        </div>
        <table v-if="!balance.loading">
            <thead>
                <tr>
                    <th colspan="2" v-if="title" class="title">
                        <mu-title type="h2" textStrong="900">
                            {{ title }} <a href="javascript:;" @click="load()"><font-awesome-icon icon="sync-alt" /> atualizar</a>
                        </mu-title>
                    </th>
                </tr>
                <tr>
                    <th>Serviço</th>
                    <th class="is-center">Créditos</th>
                    <!-- <th class="is-center">Saldo</th> -->
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, key) in balance.results" :key="key" v-bind:class="{ 'credit-zero': item.balance <= 0 }">
                    <td>{{ item.name }} <font-awesome-icon icon="exclamation-triangle" v-if="item.balance <= 0" /></td>
                    <td class="is-center credit">{{ item.balance }}</td>
                    <!-- <td class="is-center">{{ priceFormat(item.tax * item.balance, 4) }}</td> -->
                </tr>
            </tbody>
        </table>
        <mu-loading v-if="balance.loading" text="Aguarde... Estamos atualizando o saldo..."></mu-loading>
    </div>
</template>

<script>
    import BalanceServices from '@/services/dashboards/balance'

    export default {
        name: 'my-balance',

        // ╔═╗╦═╗╔═╗╔═╗╔═╗
        // ╠═╝╠╦╝║ ║╠═╝╚═╗
        // ╩  ╩╚═╚═╝╩  ╚═╝

        props: ['title', 'icon'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                balance: {
                    loading: false,
                    results: []
                }
            }
        },

        computed: {
            company () {
                return this.$store.state.company || null
            },
            balanceIsEnding () {
                let zero = this.balance.results.find(item => {
                    return item.balance <= 0
                })
                if (zero) {
                    return true
                }
                return false
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            await this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega o saldo do cliente
             */
            async load () {
                try {
                    this.balance.loading = true

                    let result = await BalanceServices.balances()

                    if (result && result.status) {
                        this.balance.results = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o saldo.')
                } finally {
                    this.balance.loading = false
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .my-balance

        table
            width 100%
            border-collapse collapse
            text-align left

            th, td
                font-size 11px
                padding 5px 5px 2px 5px
                border-bottom 1px #e0e0e0 solid
                border-left 1px #e0e0e0 solid
                border-right 1px #e0e0e0 solid

            thead
                background #dddddd
                border-bottom 1px #e0e0e0 solid

                th
                    color #656569
                    font-weight normal

            .credit
                font-size 14px
                font-weight bold

            .credit-zero
                color $red
                background lighten($red, 90%)

        .mu-alert
            margin-bottom 10px
            background $red
            color #fff
            svg
                margin-right 10px
                font-size 20px

        .title
            background #ccc
            h2
                margin 0
                font-size 14px
                color #666
                a
                    color $primary
                    font-size 11px
                    font-weight normal
                    float right

</style>
